import { useEffect, useState } from "react";
import { useLandingConfig } from "@/hooks/useLandingConfig";

/**
 * Sticky WhatsApp FAB (Floating Action Button).
 * Appare in basso a destra dopo un piccolo scroll — reachable in ogni sezione della landing.
 * Testo/telefono/messaggio predefinito sono editabili via /admin/landing-config → Sticky WhatsApp.
 */
export default function StickyWhatsApp() {
  const [visible, setVisible] = useState(false);
  const { T } = useLandingConfig();
  const phone = T("texts.sticky_whatsapp.phone_number", "393292561466");
  const message = T("texts.sticky_whatsapp.message_preset", "Ciao Epic Flow! Vorrei info.");
  const label = T("texts.sticky_whatsapp.label", "Scrivici");
  const whatsappUrl = `https://wa.me/${(phone || "").replace(/\D/g, "")}?text=${encodeURIComponent(message || "")}`;

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="sticky-whatsapp"
      aria-label={label}
      title={label}
      className={`
        fixed bottom-5 right-5 md:bottom-8 md:right-8 z-40
        w-14 h-14 md:w-16 md:h-16
        rounded-full bg-sage text-secondary-foreground
        shadow-2xl shadow-secondary/40
        flex items-center justify-center
        transition-all duration-500
        hover:scale-110 hover:shadow-secondary/60
        ${visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-6 pointer-events-none"}
      `}
    >
      {/* Alone pulsante — animato */}
      <span className="absolute inset-0 rounded-full bg-secondary/40 animate-ping" />
      {/* Icona WhatsApp */}
      <svg viewBox="0 0 24 24" className="w-7 h-7 md:w-8 md:h-8 fill-current relative" aria-hidden="true">
        <path d="M17.5 14.4c-.3-.15-1.8-.9-2.07-1-.28-.1-.48-.15-.68.15-.2.3-.78 1-.96 1.2-.18.2-.35.22-.65.08-.3-.15-1.27-.47-2.42-1.5-.9-.8-1.5-1.79-1.67-2.09-.18-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.03-.52-.08-.15-.68-1.65-.93-2.25-.25-.6-.5-.51-.68-.52h-.58c-.2 0-.52.08-.8.38-.28.3-1.05 1.02-1.05 2.5s1.08 2.9 1.23 3.1c.15.2 2.1 3.2 5.08 4.5.71.3 1.27.48 1.7.62.71.23 1.36.2 1.87.12.57-.08 1.8-.73 2.05-1.44.25-.7.25-1.3.18-1.44-.08-.13-.28-.2-.58-.35zM12 2C6.48 2 2 6.48 2 12c0 1.9.53 3.67 1.44 5.19L2 22l4.94-1.42A9.96 9.96 0 0 0 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2z"/>
      </svg>
    </a>
  );
}
